// import { AnimalPage } from "./Component/AnimalPage";
import "./App.css";
import Home from "./Home";
import { Routes, Route } from "react-router-dom";
import { AnimalPageContainer } from "./Containers/AnimalPageContainer";
import AnimalDetailPageContainer from "./Containers/AnimalDetailPageContainer";
import FormPageContainer from "./Containers/FormPageContainer";
import ReadArticlePageContainer from "./Containers/ReadArticlePageContainer";
import CreateArticlePageContainer from "./Containers/CreateArticlePageContainer";
import DeleteArticlePageContainer from "./Containers/DeleteArticlePageContainer";

function App() {
  return (
    <Routes className="App">
      <Route path="/" exact element={<Home />} />
      <Route path="/animal-page" exact element={<AnimalPageContainer />} />
      <Route path="/animal/:id" exact element={<AnimalDetailPageContainer />} />
      <Route path="/form-page" exact element={<FormPageContainer />} />
      <Route path="/read-article" exact element={<ReadArticlePageContainer />} />
      <Route path="/create-article" exact element={<CreateArticlePageContainer />} />
      <Route path="/delete-article" exact element={<DeleteArticlePageContainer />} />
    </Routes>
  );
}

export default App;
